import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    Stack,
    Button,
    Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { IDetalheProdutoEstoque } from "../../../../../../../types/api/estoque/detalhar-produto-estoque";
import { DadoValorPrinter } from "../../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { useState } from "react";
import DialogEditInformacoesBasicas from "./DialogEditInformacoesBasicas";
import { formatarDataBR } from "../../../../../../../helpers/masks";

export default function CardInformacoesBasicas({
    produto,
}: {
    produto: IDetalheProdutoEstoque;
}) {
    const [openEdit, setOpenEdit] = useState<boolean>(false);
    return (
        <Card>
            <CardContent>
                <Box>
                    <Typography variant="h6" gutterBottom>
                        Informações Básicas do Produto
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <DadoValorPrinter titulo="Nome do produto" valor={produto.nome} />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <DadoValorPrinter titulo="Código de barra" valor={produto.codigo_de_barra ? produto.codigo_de_barra : "-"} />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <DadoValorPrinter titulo="Descrição complementar"
                                valor={produto.descricao_complementar ? produto.descricao_complementar : "-"} />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <DadoValorPrinter
                                titulo="Categoria"
                                valor={produto.categorias?.[0]?.nome_categoria || "-"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <DadoValorPrinter
                                titulo="Departamento"
                                valor={produto.departamento ? `${produto.departamento.id} - ${produto.departamento.nome}` : "-"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <DadoValorPrinter
                                titulo="Setor"
                                valor={produto.setor ? `${produto.setor.id} - ${produto.setor.nome}` : "-"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <DadoValorPrinter
                                titulo="NCM"
                                valor={produto.ncm ? produto.ncm.toString() : "-"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <DadoValorPrinter
                                titulo="Tributação"
                                valor={produto.tipo_tributacao}
                            />
                        </Grid>
                    </Grid>

                    {produto.categorias && produto.categorias.length > 0 && (
                        <>
                            <Divider sx={{ my: 3 }} />
                            <Typography variant="h6" gutterBottom>
                                Atributos da Categoria
                            </Typography>
                            <Grid container spacing={2}>
                                {produto.categorias.map((categoria, index) => (
                                    categoria.atributos && Object.keys(categoria.atributos).length > 0 && (
                                        Object.entries(categoria.atributos).map(([chave, valor]) => (
                                            <Grid size={{ xs: 12, md: 6 }} key={`${index}-${chave}`}>
                                                <DadoValorPrinter
                                                    titulo={chave}
                                                    valor={formatarDataBR(valor) as string}
                                                />
                                            </Grid>
                                        ))
                                    )
                                ))}
                            </Grid>
                        </>
                    )}

                    <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
                        <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={<EditIcon />}
                            onClick={() => setOpenEdit(true)}
                        >
                            Editar
                        </Button>
                    </Stack>
                </Box>
            </CardContent>
            <DialogEditInformacoesBasicas
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                produto={produto}
            />
        </Card>
    );
}